import { render, staticRenderFns } from "./K2PrintFromURL.vue?vue&type=template&id=44a7b682"
import script from "./K2PrintFromURL.vue?vue&type=script&lang=js"
export * from "./K2PrintFromURL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports